/**
 * Orvi Homepage Popup Integration for Shopify Theme
 * 
 * This file should be uploaded to your Shopify theme's assets folder
 * and included in the homepage popup liquid file or theme.liquid before the closing </body> tag
 * 
 * Usage in theme.liquid:
 * {{ 'shopify-homepage-popup.js' | asset_url | script_tag }}
 */

// Homepage Popup Zoho CRM Integration
function initializeHomepagePopupIntegration() {
  // Homepage Popup Integration loaded

  // Find the homepage popup form
  const popupForm = document.querySelector('#contact_form_home, #ContactForm');

  if (!popupForm) {
    // Homepage popup form not found
    return;
  }

  // Check if it's the homepage popup (has the custompopupshow class or orvi-homepage-main)
  const isHomepagePopup = document.querySelector('.custompopupshow, .orvi-homepage-main');

  if (!isHomepagePopup) {
    // Not homepage popup context
    return;
  }

  // Homepage popup form found, setting up integration

  // Setup form handler
  setupHomepagePopupForm(popupForm);

  // Setup popup display logic with optimal timing
  setupPopupDisplay();
}

function setupHomepagePopupForm(form) {
  // Check if form manager is available
  if (!window.OrviFormManager) {
    return; // Form manager not loaded
  }

  // User Request: Change Form Name - 1st Name, 2nd - email, 3rd Phone Number, 4th City
  // And remove Birthday

  // 1. Remove Birthday if present
  const birthdayInput = form.querySelector('input[name="contact[birthday]"], input[name*="birthday"]');
  if (birthdayInput) {
    const container = birthdayInput.closest('div') || birthdayInput;
    container.style.display = 'none'; // Hide instead of remove to avoid breaking scripts
    // Or remove if safe
    // container.remove(); 
  }

  // 2. Inject City if missing
  const cityInputExists = form.querySelector('input[name="contact[city]"], input[name="contact[City]"]');
  if (!cityInputExists) {
    const phoneInput = form.querySelector('input[name="contact[phone]"]');
    if (phoneInput) {
      const cityWrapper = document.createElement('div');
      const inputClass = phoneInput.className;
      const parentClass = phoneInput.parentElement.className;

      cityWrapper.className = parentClass || 'form-group';
      cityWrapper.innerHTML = `<input type="text" name="contact[City]" class="${inputClass}" placeholder="City" required>`;

      const phoneContainer = phoneInput.closest('div') || phoneInput;
      phoneContainer.after(cityWrapper);
    }
  }

  // 3. Reorder fields (Name -> Email -> Phone -> City)
  // Try to reorder immediately upon setup if elements exist
  try {
    const emailInput = form.querySelector('input[name="contact[email]"], input[type="email"], input[id="ContactFormEmail"]');
    const firstNameInput = form.querySelector('input[name="contact[first_name]"], input[id="ContactFormFirstName"], input[name="first_name"]');
    const phoneInput = form.querySelector('input[name="contact[phone]"], input[type="tel"], input[id="ContactFormPhone"]');
    const cityInput = form.querySelector('input[name="contact[city]"], input[name="contact[City]"], input[id="ContactFormCity"]');

    if (firstNameInput && emailInput && phoneInput && cityInput) {
      const p1 = firstNameInput.closest('div') || firstNameInput;
      const p2 = emailInput.closest('div') || emailInput;
      const p3 = phoneInput.closest('div') || phoneInput;
      const p4 = cityInput.closest('div') || cityInput;

      const parent = p1.parentElement;
      if (parent && parent === p2.parentElement && parent === p3.parentElement && parent === p4.parentElement) {
        // All in same container, we can reorder
        parent.appendChild(p1); // 1. Name
        parent.appendChild(p2); // 2. Email
        parent.appendChild(p3); // 3. Phone
        parent.appendChild(p4); // 4. City
        // Append submit button at the end if it's a sibling
        const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitBtn && submitBtn.parentElement === parent) {
          parent.appendChild(submitBtn);
        }
      }
    }
  } catch (e) { console.log('Reordering failed during setup', e); }

  // Check if already handled
  if (window.OrviFormManager.isFormHandled(form)) {
    return;
  }

  const submitHandler = async function (e) {
    e.preventDefault();

    // Homepage popup form submitted

    // Find inputs
    const emailInput = this.querySelector('input[name="contact[email]"], input[type="email"], input[id="ContactFormEmail"]');
    const firstNameInput = this.querySelector('input[name="contact[first_name]"], input[id="ContactFormFirstName"], input[name="first_name"]');
    const phoneInput = this.querySelector('input[name="contact[phone]"], input[type="tel"], input[id="ContactFormPhone"]');
    const cityInput = this.querySelector('input[name="contact[city]"], input[name="contact[City]"], input[id="ContactFormCity"]');

    // Order Check for Injection (if we want to enforce visual order via JS, it's tricky without flexbox ordering or moving elements)
    // The prompt asks for: 1st Name, 2nd Email, 3rd Phone, 4th City
    // We injected City after phone already. 
    // Let's try to reorder if elements exist and are in the same parent container
    try {
      if (firstNameInput && emailInput && phoneInput && cityInput) {
        const p1 = firstNameInput.closest('div') || firstNameInput;
        const p2 = emailInput.closest('div') || emailInput;
        const p3 = phoneInput.closest('div') || phoneInput;
        const p4 = cityInput.closest('div') || cityInput;

        const parent = p1.parentElement;
        if (parent && parent === p2.parentElement && parent === p3.parentElement && parent === p4.parentElement) {
          // All in same container, we can reorder
          parent.appendChild(p1); // 1. Name
          parent.appendChild(p2); // 2. Email
          parent.appendChild(p3); // 3. Phone
          parent.appendChild(p4); // 4. City
          // Append submit button at the end if it's a sibling
          const submitBtn = this.querySelector('button[type="submit"], input[type="submit"]');
          if (submitBtn && submitBtn.parentElement === parent) {
            parent.appendChild(submitBtn);
          }
        }
      }
    } catch (e) { console.log('Reordering failed', e); }

    if (!emailInput) {
      return;
    }

    const email = emailInput.value.trim();
    const firstName = firstNameInput ? firstNameInput.value.trim() : '';
    const phone = phoneInput ? phoneInput.value.trim() : '';
    const city = cityInput ? cityInput.value.trim() : '';

    // Validation - All Mandatory
    if (!email || !/^[^@]+@[^@]+\.[^@]+$/.test(email)) {
      return;
    }
    if (!firstName) {
      // First Name Mandatory
      return;
    }
    if (!phone) {
      // Phone Mandatory
      return;
    }
    if (!city) {
      // City Mandatory
      return;
    }

    await submitHomepagePopup(this, {
      email: email,
      firstName: firstName,
      phone: phone,
      city: city,
      leadSource: 'Homepage Popup',
      sourceByGroup: 'Subscription'
    });
  };

  // Add event listener directly
  form.addEventListener('submit', submitHandler);
  form.setAttribute('data-orvi-handled', 'homepage-popup-script');
}

async function submitHomepagePopup(form, data) {
  // Show loading state
  const submitBtn = form.querySelector('button[type="submit"], input[type="submit"], #contact-home-button');
  const originalValue = submitBtn ? (submitBtn.value || submitBtn.textContent) : '';

  if (submitBtn) {
    if (submitBtn.tagName === 'INPUT') {
      submitBtn.value = 'SUBMITTING...';
    } else {
      submitBtn.textContent = 'SUBMITTING...';
    }
    submitBtn.disabled = true;
  }

  try {
    const netlifyUrl = 'https://orvizoho.netlify.app/.netlify/functions/homepage-popup';

    const response = await fetch(netlifyUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    });

    const result = await response.json();

    if (response.ok && result.success) {
      // Success handling
      // Reset form and hide popup
      form.reset();
      hidePopup();

      // Set cookie to prevent popup for 365 days
      setCookie('homepagePopupCompleted', 'true', 365);

    } else {
      // Fail silently
    }
  } catch (err) {
    // Network error occurred
  } finally {
    // Restore button state
    if (submitBtn) {
      if (submitBtn.tagName === 'INPUT') {
        submitBtn.value = originalValue;
      } else {
        submitBtn.textContent = originalValue;
      }
      submitBtn.disabled = false;
    }
  }
}

function hidePopup() {
  // Hide popup using existing methods
  const popup = document.querySelector('.orvi-homepage-main, .custompopupshow');
  if (popup) {
    popup.style.display = 'none';
    popup.classList.remove('orvi-homepage-main');
  }

  // Remove popup classes
  const custompopupshow = document.querySelector('.custompopupshow');
  if (custompopupshow) {
    custompopupshow.classList.remove('orvi-homepage-main');
  }

  // Call existing close function if available
  if (typeof ageCheck === 'function') {
    ageCheck();
  }
}

function setupPopupDisplay() {
  // Enhanced popup display logic

  // Check if user has already completed popup
  if (getCookie('homepagePopupCompleted') || getCookie('isAnAdult') || getCookie('isAnAdult3')) {
    // User has already completed popup, not showing
    return;
  }

  // Check if user is on homepage
  const isHomepage = window.location.pathname === '/' ||
    window.location.pathname === '/index' ||
    document.body.id === 'orvi-home-stylish-handcrafted-home-decor-product-range';

  if (!isHomepage) {
    // Not on homepage, not showing popup
    return;
  }

  // Intelligent popup timing based on user engagement
  let popupShown = false;

  // Method 1: Time-based (10 seconds as per original)
  setTimeout(() => {
    if (!popupShown) {
      showPopup();
      popupShown = true;
    }
  }, 10000);

  // Method 2: Scroll-based (when user scrolls 50% of page)
  let scrollTriggered = false;
  window.addEventListener('scroll', () => {
    if (scrollTriggered || popupShown) return;

    const scrollPercentage = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    if (scrollPercentage > 50) {
      scrollTriggered = true;
      setTimeout(() => {
        if (!popupShown) {
          showPopup();
          popupShown = true;
        }
      }, 2000);
    }
  });

  // Method 3: Exit intent (when mouse leaves viewport)
  let exitIntentTriggered = false;
  document.addEventListener('mouseleave', (e) => {
    if (exitIntentTriggered || popupShown) return;
    if (e.clientY <= 0) {
      exitIntentTriggered = true;
      setTimeout(() => {
        if (!popupShown) {
          showPopup();
          popupShown = true;
        }
      }, 1000);
    }
  });

  // Method 4: Time on page (after 30 seconds of activity)
  let timeOnPage = 0;
  const pageTimer = setInterval(() => {
    timeOnPage += 1000;
    if (timeOnPage >= 30000 && !popupShown) {
      showPopup();
      popupShown = true;
      clearInterval(pageTimer);
    }
  }, 1000);

  // Clear timer if popup is shown by other means
  const checkPopupShown = () => {
    if (popupShown) {
      clearInterval(pageTimer);
    }
  };
  setInterval(checkPopupShown, 1000);
}

function showPopup() {
  // Showing homepage popup

  // Use existing popup display logic
  const custompopupshow = document.querySelector('.custompopupshow');
  if (custompopupshow) {
    custompopupshow.classList.add('orvi-homepage-main');
  }

  // Ensure popup is visible
  const popup = document.querySelector('.orvi-homepage-main');
  if (popup) {
    popup.style.display = 'flex';
  }
}

// Cookie utility functions
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Multiple initialization methods for Shopify compatibility
// Method 1: DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHomepagePopupIntegration);
} else {
  // Method 2: DOM already loaded
  initializeHomepagePopupIntegration();
}

// Method 3: Window load (fallback)
window.addEventListener('load', function () {
  setTimeout(initializeHomepagePopupIntegration, 1000);
});

// Method 4: Shopify theme events (if available)
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function (event) {
    setTimeout(initializeHomepagePopupIntegration, 500);
  });
}

// Export for manual initialization if needed
window.initializeHomepagePopupIntegration = initializeHomepagePopupIntegration;